import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

/** One merged inbox row (personal notification OR admin broadcast). */
export interface InboxNotification {
  id: string;                 // "p<id>" (personal) or "b<id>" (broadcast)
  source: "personal" | "broadcast";
  type: string | null;
  title: string;
  body: string;
  url: string | null;
  isRead: boolean;
  createdAt: string | null;
}

export const INBOX_LIST_KEY = ["/api/notifications/inbox"] as const;
export const INBOX_UNREAD_KEY = ["/api/notifications/inbox/unread-count"] as const;

export function useNotificationInbox(options?: { enabled?: boolean }) {
  return useQuery<{ notifications: InboxNotification[] }>({
    queryKey: INBOX_LIST_KEY,
    enabled: options?.enabled ?? true,
    refetchInterval: 60000,
  });
}

export function useNotificationInboxUnread(options?: { enabled?: boolean }) {
  return useQuery<{ count: number }>({
    queryKey: INBOX_UNREAD_KEY,
    enabled: options?.enabled ?? true,
    refetchInterval: 30000,
  });
}

export function useMarkInboxAllRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await apiRequest("POST", "/api/notifications/inbox/read-all");
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: INBOX_LIST_KEY });
      queryClient.invalidateQueries({ queryKey: INBOX_UNREAD_KEY });
    },
  });
}
